import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { __ } from '@wordpress/i18n';
import { downloadPdf } from './pdf';

// Always renders the calculation as it is *now* (see PdfRoutes.php's
// `POST /pdf`) — unlike the PDF stored for HubSpot, which keeps the values
// from the moment the lead form was submitted.
const PdfDownloadButton = ( { pdfSettings, getInput } ) => {
	const [ status, setStatus ] = useState( 'idle' );

	const download = () => {
		setStatus( 'loading' );
		downloadPdf( pdfSettings, getInput() )
			.then( () => setStatus( 'idle' ) )
			.catch( () => setStatus( 'error' ) );
	};

	return (
		<div className="roi-calculator__pdf-download">
			<button
				type="button"
				className="roi-calculator__pdf-download-button"
				onClick={ download }
				disabled={ status === 'loading' }
			>
				{ status === 'loading'
					? __( 'Creating PDF…', 'sprintray-roi-calculator' )
					: __( 'Download PDF', 'sprintray-roi-calculator' ) }
			</button>
			{ status === 'error' && (
				<span
					className="roi-calculator__pdf-download-error"
					role="alert"
				>
					{ __(
						'The PDF could not be created. Please try again later.',
						'sprintray-roi-calculator'
					) }
				</span>
			) }
		</div>
	);
};

PdfDownloadButton.propTypes = {
	pdfSettings: PropTypes.shape( {
		restUrl: PropTypes.string.isRequired,
	} ).isRequired,
	getInput: PropTypes.func.isRequired,
};

export default PdfDownloadButton;
